import { render, staticRenderFns } from "./LeadsGridContentEdit.vue?vue&type=template&id=13000f4b"
import script from "./LeadsGridContentEdit.vue?vue&type=script&lang=ts"
export * from "./LeadsGridContentEdit.vue?vue&type=script&lang=ts"
import style0 from "./LeadsGridContentEdit.vue?vue&type=style&index=0&id=13000f4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports